import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { demoService } from '../services';

const DemoContext = createContext(null);

export function DemoProvider({ children }) {
  const [demoMode, setDemoMode] = useState(false);
  const [canToggle, setCanToggle] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const data = await demoService.getStatus();
      setDemoMode(data.demo_mode);
      setCanToggle(data.can_toggle);
    } catch {
      // silently fail for unauthenticated users
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const toggle = async () => {
    if (!canToggle) return;
    const data = await demoService.toggle();
    setDemoMode(data.demo_mode);
    return data;
  };

  return (
    <DemoContext.Provider value={{ demoMode, canToggle, loaded, refresh, toggle }}>
      {children}
    </DemoContext.Provider>
  );
}

export function useDemo() {
  const ctx = useContext(DemoContext);
  if (!ctx) throw new Error('useDemo must be used within DemoProvider');
  return ctx;
}
